import { ReactElement } from "react";
import { IAddStorageModalProps } from "./types";
import { Box, Text } from "@mantine/core";
import { AddOnConfirmModal } from "@addons/components/AddOnConfirmModal";
import IconDWH from "@common/components/icons/IconDWH";

export default function AddStorageModal({
  opened,
  title,
  description,
  onClose,
}: IAddStorageModalProps): ReactElement {
  return (
    <AddOnConfirmModal
      testId="AddStorage-modal"
      title="Add storage?"
      icon={<IconDWH />}
      confirmLabel="Add storage"
      opened={opened}
      onClose={onClose}
    >
      <Box>
        <Text c="gray.7" fz="sm" ta="center">
          {title}
        </Text>

        <Text c="gray.4" fz="sm" mt="xs" ta="center">
          {description}
        </Text>
      </Box>
    </AddOnConfirmModal>
  );
}
